import * as React from "react";
import { cn } from "@/lib/utils";

export interface FieldListItem {
  label: string;
  value: React.ReactNode;
}

export interface FieldListProps {
  items: ReadonlyArray<FieldListItem>;
  /** Tailwind class for the label column width. Defaults to a sensible width. */
  labelColumnClassName?: string;
  className?: string;
}

export function FieldList({ items, labelColumnClassName, className }: FieldListProps) {
  return (
    <dl
      className={cn(
        "grid grid-cols-[max-content_1fr] gap-x-4 gap-y-2 text-sm",
        className,
      )}
    >
      {items.map((item, idx) => (
        <React.Fragment key={`${item.label}-${idx}`}>
          <dt className={cn("text-muted-foreground", labelColumnClassName)}>
            {item.label}:
          </dt>
          <dd className="text-foreground m-0">{item.value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
}
